import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";


// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {taskDefinitionSuccess} = isOfflineDev ? await import("../tests/fixtures/tasks.js") : {};
const {users} = isOfflineDev ? await import("@/tests/fixtures/Users.js") : {};
const {employeesSuccess} = isOfflineDev ? await import("@/tests/fixtures/Employees.js") : {};
const {teamsSuccess} = isOfflineDev ? await import("@/tests/fixtures/Teams.js") : {};

export async function getAllEmployees(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
      return fetch(BACKEND_API_PLACEHOLDER + '/api/manager_tools/employees/all', {
        method: 'GET',
        headers: headers,
      })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return employeesSuccess
}

export async function getEmployeeQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/manager_tools/employees/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getUserRefQuery(query, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/query?'
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) {
        if (typeof category_value == 'string' && category_value.includes('&')) {
          let values = category_value.split('&')
          for (let i = 0; i < values.length; i++) url += `${(idx > 0 || i > 0) ? '&' : ''}${category_name}=${values[i]}`
        }
        else url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
      }
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json()
    .then(data => { return data })
    )
  }
  else return {
    status: 200,
    data: users
  }
}

export async function syncUserRefs(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/sync_users'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: null
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postInviteUser(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/invite'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function submitEmployeeChanges(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/employees/update'
  return fetch(url, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postAddSites(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/add_sites'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postDeactivateSites(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/deactivate'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postActivateSites(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/activate'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postRevokeInvitation(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/revoke'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function postResendInvitation(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/resend_invite'
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function getEmployee(employeeId, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/employees/id?id=${employeeId}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
  )
}

export async function putEmployeeEdit(employeeId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/employees/id?id=${employeeId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEmployeePermissionsEdit(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/employees/permissions`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAllTeams(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/manager_tools/teams/all', {
      method: 'GET',
      headers: headers,
    })
    .then(res => res.json()
    .then(data => { return data })
    )
  }
  else return teamsSuccess
}

export async function postCreateTeam(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/manager_tools/teams/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postCreateProcedure(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/manager_tools/tools/procedure/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditProcedure(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/tools/procedure/edit/id?id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postCreateTask(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/manager_tools/tools/task_def/new', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditTask(taskId, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/tools/task_def/edit?id=${taskId}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getProcedureQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/manager_tools/tools/procedure/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getSpecificProcedure(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/tools/procedure/id?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getTaskDefinitionsByProcedureId(procedure_id, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/manager_tools/tools/procedure/task_definitions?procedure_id=${procedure_id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return taskDefinitionSuccess
}

export async function getAdminLogsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/user_management/admin_logs/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) {
      if (typeof category_value == 'string' && category_value.includes('&')) {
        let values = category_value.split('&')
        for (let i = 0; i < values.length; i++) url += `${(idx > 0 || i > 0) ? '&' : ''}${category_name}=${values[i]}`
      }
      else url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
    )
}